import { render, staticRenderFns } from "./FormProfissional.vue?vue&type=template&id=6fcb40dc"
import script from "./FormProfissional.vue?vue&type=script&lang=js"
export * from "./FormProfissional.vue?vue&type=script&lang=js"
import style0 from "./FormProfissional.vue?vue&type=style&index=0&id=6fcb40dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports